import React, { Component } from "react";
import AntdCascader, {CascaderProps} from 'antd/lib/cascader';
import 'antd/lib/cascader/style';

interface CProps extends CascaderProps {
  forwardedRef?: any;
};
class Cascader extends Component<CProps> {
    render() {
        const { forwardedRef, ...rest } = this.props;
        return (
          <AntdCascader ref={forwardedRef} {...rest} />
        )
    }
}
export default React.forwardRef((props: CProps, ref) => {
    return (
      <Cascader {...props} forwardedRef={ref} />
    )
});




// WEBPACK FOOTER //
// ./src/components/cascader/index.tsx